import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFrame = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	width: 20,
	height: 20,
	strokeWidth: 1.5,
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M4 7l16 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M4 17l16 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M7 4l0 16" }),
		/* @__PURE__ */ _jsx("path", { d: "M17 4l0 16" })
	]
});
const ForwardRef = forwardRef(SvgFrame);
export default ForwardRef;
